export const columns = [
  { field: "serialNumber", headerName: "Serial Number" },
  { field: "president", headerName: "President" },
  { field: "secretary", headerName: "Secretary" },
  { field: "year", headerName: "Year" },
];

export const data = [
  {
    serialNumber: 1,
    president: "Shri S. C. Kawar",
    secretary: "Shri Ch. Nain Singh",
    year: "1964-65",
  },
  {
    serialNumber: 2,
    president: "Shri V. P. Mishra",
    secretary: "Shri Ch. Nain Singh",
    year: "1965-66",
  },
  {
    serialNumber: 3,
    president: "Shri V. P. Mishra",
    secretary: "Shri Ch. Nain Singh",
    year: "1966-67",
  },
  {
    serialNumber: 4,
    president: "Shri Raneshwer Singh",
    secretary: "Shri S. S. Hairat",
    year: "1967-68",
  },
  {
    serialNumber: 5,
    president: "Shri Raneshwer Singh",
    secretary: "Shri S. S. Hairat",
    year: "1968-69",
  },
  {
    serialNumber: 6,
    president: "Shri Raneshwer Singh",
    secretary: "Shri Ravinder Nath",
    year: "1969-70",
  },
  {
    serialNumber: 7,
    president: "Shri Raneshwer Singh",
    secretary: "Shri Ravinder Nath",
    year: "1970-71",
  },
  {
    serialNumber: 8,
    president: "Shri M. S. Seth",
    secretary: "Shri Ravinder Nath",
    year: "1971-72",
  },
  {
    serialNumber: 9,
    president: "Shri R. K. Sinah",
    secretary: "Shri Jitendra Kumar",
    year: "1972-73",
  },
  {
    serialNumber: 10,
    president: "Shri R. S. Saklani",
    secretary: "Shri Laxmikanth Upaydhya",
    year: "1973-74",
  },
  {
    serialNumber: 11,
    president: "Shri Bheem Sen Bhatia",
    secretary: "Shri R.P.Saini",
    year: "1974-75",
  },
  {
    serialNumber: 12,
    president: "Shri Bheem Sen Bhatia",
    secretary: "Shri R.P.Saini",
    year: "1975-76",
  },
  {
    serialNumber: 13,
    president: "Shri V. P. Mishra",
    secretary: "Shri Givind Ram Nautiyal",
    year: "1976-77",
  },
  {
    serialNumber: 14,
    president: "Shri Nityanand Swami",
    secretary: "Shri D. S. Man",
    year: "1977-78",
  },
  {
    serialNumber: 15,
    president: "Shri I. M. Saklani",
    secretary: "Shri Ashok Kumar Aggarwal",
    year: "1978-79",
  },
  {
    serialNumber: 16,
    president: "Shri M. K. Naglia",
    secretary: "Shri Surat Singh Negi",
    year: "1979-80",
  },
  {
    serialNumber: 17,
    president: "Shri M. K. Naglia",
    secretary: "Shri Surat Singh Negi",
    year: "1980-81",
  },
  {
    serialNumber: 18,
    president: "Shri Y. P. Bhatia",
    secretary: "Shri Raghuveer Singh Solanki",
    year: "1981-82",
  },
  {
    serialNumber: 19,
    president: "Shri Y. P. Bhatia",
    secretary: "Shri Raghuveer Singh Solanki",
    year: "1982-83",
  },
  {
    serialNumber: 20,
    president: "Shri Surendra Singh Negi",
    secretary: "Shri Dinesh Aggarwal",
    year: "1983-84",
  },
  {
    serialNumber: 21,
    president: "Shri Surendra Singh Negi",
    secretary: "Shri Dinesh Aggarwal",
    year: "1984-85",
  },
  {
    serialNumber: 22,
    president: "Shri P. D. Sharma",
    secretary: "Shri Dinesh Aggarwal",
    year: "1985-86",
  },
  {
    serialNumber: 23,
    president: "Shri P. D. Sharma",
    secretary: "Shri Dinesh Aggarwal",
    year: "1986-87",
  },
  {
    serialNumber: 24,
    president: "Shri Ch. Nain Singh",
    secretary: "Shri Dinesh Aggarwal",
    year: "1987-88",
  },
  {
    serialNumber: 25,
    president: "Shri Ch. Nain Singh",
    secretary: "Shri Dinesh Aggarwal",
    year: "1988-89",
  },
  {
    serialNumber: 26,
    president: "Shri Ch. Nain Singh",
    secretary: "Shri Dinesh Aggarwal",
    year: "1989-90",
  },
  {
    serialNumber: 27,
    president: "Shri Ch. Nain Singh",
    secretary: "Shri Ashok Aggarwal",
    year: "1990-91",
  },
  {
    serialNumber: 28,
    president: "Shri S. C. Maurya",
    secretary: "Shri S. S. Tadiyal",
    year: "1991-92",
  },
  {
    serialNumber: 29,
    president: "Shri S. C. Maurya / Jitandar Kumar",
    secretary: "Shri Mukesh Mahendra",
    year: "1992-93",
  },
  {
    serialNumber: 30,
    president: "Shri Surat Singh Negi",
    secretary: "Shri Rajpal Singh Pundir",
    year: "1993-94",
  },
  {
    serialNumber: 31,
    president: "Shri Surat Singh Negi",
    secretary: "Shri Ashok Aggarwal",
    year: "1994-95",
  },
  {
    serialNumber: 32,
    president: "Shri Prem Chand Sharma",
    secretary: "Shri B. P. Nautiyal",
    year: "1995-96",
  },
  {
    serialNumber: 33,
    president: "Shri Prem Chand Sharma",
    secretary: "Shri B. P. Nautiyal",
    year: "1996-97",
  },
  {
    serialNumber: 34,
    president: "Shri Prem Chand Sharma",
    secretary: "Shri Surendra Pundir",
    year: "1997-98",
  },
  {
    serialNumber: 35,
    president: "Shri Prem Chand Sharma",
    secretary: "Shri Surendra Pundir",
    year: "1998-99",
  },
  {
    serialNumber: 36,
    president: "Shri S. C. Maurya",
    secretary: "Shri Surendra Pundir",
    year: "1999-2000",
  },
  {
    serialNumber: 37,
    president: "Shri Prem Chand Sharma",
    secretary: "Shri Surendra Pundir",
    year: "2000-01",
  },
  {
    serialNumber: 38,
    president: "Shri Dinesh Aggarwal",
    secretary: "Shri Surendra Pundir",
    year: "2001-02",
  },
  {
    serialNumber: 39,
    president: "Shri S. C. Maurya",
    secretary: "Shri Shiv Charan Singh Rawat",
    year: "2002-03",
  },
  {
    serialNumber: 40,
    president: "Shri S. S.Tadiyal",
    secretary: "Shri Mukesh Mahendra",
    year: "2003-04",
  },
  {
    serialNumber: 41,
    president: "Shri S. S.Tadiyal",
    secretary: "Shri Mukesh Mahendra",
    year: "2004-05",
  },
  {
    serialNumber: 42,
    president: "Shri Prem Chand Sharma",
    secretary: "Shri Rajeev Sharma",
    year: "2005-06",
  },
  {
    serialNumber: 43,
    president: "Shri Prem Chand Sharma",
    secretary: "Shri Rajeev Sharma",
    year: "2006-07",
  },
  {
    serialNumber: 44,
    president: "Shri O. P. Saklani",
    secretary: "Shri Kamaldeep Mehta",
    year: "2007-08",
  },
  {
    serialNumber: 45,
    president: "Shri Rajpal Singh Pundir",
    secretary: "Shri Prithiviraj Chauhan",
    year: "2008-09",
  },
  {
    serialNumber: 46,
    president: "Shri Rajpal Singh Pundir",
    secretary: "Shri Rajeev Sharma",
    year: "2009-10",
  },
  {
    serialNumber: 47,
    president: "Shri Manmohan Kandwal",
    secretary: "Shri Rajeev Sharma",
    year: "2010-11",
  },
  {
    serialNumber: 48,
    president: "Shri Manmohan Kandwal",
    secretary: "Shri Anil Gandhi",
    year: "2011-12",
  },
  {
    serialNumber: 49,
    president: "Shri Surender Pundir",
    secretary: "Shri Rajeev Sharma",
    year: "2012-13",
  },
  {
    serialNumber: 50,
    president: "Shri Surender Pundir",
    secretary: "Shri Raghuveer Singh Kathath",
    year: "2013-14",
  },
  {
    serialNumber: 51,
    president: "Shri Rajeev Sharma",
    secretary: "Shri Raghuveer Singh Kathath",
    year: "2014-15",
  },
  {
    serialNumber: 52,
    president: "Shri Manmohan Kandwal",
    secretary: "Shri Anil Gandhi",
    year: "2015-16",
  },
  {
    serialNumber: 53,
    president: "Shri Manmohan Kandwal",
    secretary: "Shri Anil Gandhi",
    year: "2016-17",
  },
  {
    serialNumber: 54,
    president: "Shri Rajeev Sharma",
    secretary: "Shri Anil Pandit",
    year: "2017-18",
  },
  {
    serialNumber: 55,
    president: "Shri Manmohan Kandwal",
    secretary: "Shri Anil Kumar Sharma",
    year: "2018-19",
  },
  {
    serialNumber: 56,
    president: "Shri Manmohan Kandwal",
    secretary: "Shri Anil Kumar Sharma",
    year: "2019-20",
  },
  {
    serialNumber: 57,
    president: "Shri Manmohan Kandwal",
    secretary: "Shri Anil Kumar Sharma",
    year: "2020-21",
  },
  {
    serialNumber: 58,
    president: "Shri Manmohan Kandwal",
    secretary: "Shri Anil Kumar Sharma",
    year: "2021-22",
  },
  {
    serialNumber: 59,
    president: "Shri Manmohan Kandwal",
    secretary: "Shri Anil Kumar Sharma",
    year: "2022-23",
  },
  {
    serialNumber: 60,
    president: "Shri Anil Kumar Sharma",
    secretary: "Shri Rajbeer Singh Bisht",
    year: "2023-24",
  },
  {
    serialNumber: 61,
    president: "Shri Rajeev Sharma",
    secretary: "Shri Rajbeer Singh Bisht",
    year: "2024-25",
  },
  {
    serialNumber: 61,
    president: "Shri Manmohan Kandwal",
    secretary: "Shri Rajbeer Singh Bisht",
    year: "2025-26",
  },
];
